import { connect } from 'react-redux';
import { toggleDamzPage, toggleBurgerMenuRequested, openDamzDropdown, closeDamzDropdown } from '../../redux/actions';
import { getDamzHeaderCount, getIsDamzDropdownOpen } from '../../redux/selectors';
const mapStateToProps = (state)=>({
        isDamzPageOpen: false,
        unreadCount: getDamzHeaderCount(state),
        isDamzDropdownOpen: getIsDamzDropdownOpen(state)
    });
const mapDispatchToProps = {
    toggleDamzPage,
    toggleBurgerMenu: toggleBurgerMenuRequested,
    openDamzDropdown,
    closeDamzDropdown
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=DamzDropdownWrapper.container.js.map